import { render, staticRenderFns } from "./OrderTagKeysNew.vue?vue&type=template&id=6c293d5c&"
import script from "./OrderTagKeysNew.vue?vue&type=script&lang=js&"
export * from "./OrderTagKeysNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports